import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

import { getCicAlertCounts } from './getCicAlertCounts';

export const GET_CIC_ALERTS_REQUEST = 'GET_CIC_ALERTS_REQUEST';
export const GET_CIC_ALERTS_SUCCESS = 'GET_CIC_ALERTS_SUCCESS';
export const GET_CIC_ALERTS_FAILURE = 'GET_CIC_ALERTS_FAILURE';

function requestGetCicAlerts() {
  return {
    type: GET_CIC_ALERTS_REQUEST,
    isCicAlertsListLoading: true
  };
}

function receiveGetCicAlerts(cicAlertsList, cicAlertsListCount) {
  return {
    type: GET_CIC_ALERTS_SUCCESS,
    isCicAlertsListLoading: false,
    cicAlertsList,
    cicAlertsListError: null,
    cicAlertsListCount
  };
}

function rejectGetCicAlerts(cicAlertsListError) {
  return {
    type: GET_CIC_ALERTS_FAILURE,
    isCicAlertsListLoading: false,
    cicAlertsListError
  };
}

export function getCicAlerts(resolved, pageNumber, pageSize, totalLimit, sortByField, sortDirection, filterList, raisedWithin, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected, customer, customerSelected) {
  return (dispatch) => {
    dispatch(requestGetCicAlerts());

    const promise = () => ApiService
      .getCicAlerts(resolved, pageNumber, pageSize, totalLimit, sortByField, sortDirection, filterList, raisedWithin, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected, customer, customerSelected)
      .then((response) => {
        dispatch(receiveGetCicAlerts(response.data.items, response.data.totalCount));
        dispatch(getCicAlertCounts());
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetCicAlerts, true));
        }
      });
    return promise();
  };
}

export function getUserCicAlerts(pageNumber, pageSize, totalLimit, sortByField, sortDirection, filterList, raisedWithin, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected, customer, customerSelected) {
  return (dispatch) => {
    dispatch(requestGetCicAlerts());

    const promise = () => ApiService
      .getUserCicAlerts(pageNumber, pageSize, totalLimit, sortByField, sortDirection, filterList, raisedWithin, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected, customer, customerSelected)
      .then((response) => {
        dispatch(receiveGetCicAlerts(response.data.items, response.data.totalCount));
        dispatch(getCicAlertCounts());
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetCicAlerts, true));
        }
      });
    return promise();
  };
}

export function getWorkflowCicAlerts(workflowStage, pageNumber, pageSize, totalLimit, sortByField, sortDirection, filterList, raisedWithin, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected, customer, customerSelected) {
  return (dispatch) => {
    dispatch(requestGetCicAlerts());

    const promise = () => ApiService
      .getWorkflowCicAlerts(workflowStage, pageNumber, pageSize, totalLimit, sortByField, sortDirection, filterList, raisedWithin, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected, customer, customerSelected)
      .then((response) => {
        dispatch(receiveGetCicAlerts(response.data.items, response.data.totalCount));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetCicAlerts, true));
        }
      });
    return promise();
  };
}

export function getCicAlertsByObject(requestObject) {
  return getCicAlerts(
    requestObject.resolved,
    requestObject.pageNumber,
    requestObject.pageSize,
    requestObject.totalLimit,
    requestObject.sortByField,
    requestObject.sortDirection,
    requestObject.filterList,
    requestObject.raisedWithin,
    requestObject.legalEntity,
    requestObject.legalEntitySelected,
    requestObject.accountNumber,
    requestObject.accountNumberSelected,
    requestObject.customer,
    requestObject.customerSelected
  );
}

export function getUserCicAlertsByObject(requestObject) {
  return getUserCicAlerts(
    requestObject.pageNumber,
    requestObject.pageSize,
    requestObject.totalLimit,
    requestObject.sortByField,
    requestObject.sortDirection,
    requestObject.filterList,
    requestObject.raisedWithin,
    requestObject.legalEntity,
    requestObject.legalEntitySelected,
    requestObject.accountNumber,
    requestObject.accountNumberSelected,
    requestObject.customer,
    requestObject.customerSelected
  );
}

export function getWorkflowCicAlertsByObject(requestObject) {
  return getWorkflowCicAlerts(
    requestObject.stage,
    requestObject.pageNumber,
    requestObject.pageSize,
    requestObject.totalLimit,
    requestObject.sortByField,
    requestObject.sortDirection,
    requestObject.filterList,
    requestObject.raisedWithin,
    requestObject.legalEntity,
    requestObject.legalEntitySelected,
    requestObject.accountNumber,
    requestObject.accountNumberSelected,
    requestObject.customer,
    requestObject.customerSelected
  );
}
